import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Supplier } from "./supplier.entity";
import { FarmsLog } from "./farms-log-entity";
import { FarmTypeEnum } from "@gtpl/shared-models/masters";

// import { VendorsPriceList } from "../vendors-price-list/entities/vendor-price-list.entity";

@Entity('farms')
export class Farm {

    @PrimaryGeneratedColumn("increment", { name: 'farm_id' })
    farmId: number;

    @Column("char", {
        nullable: false,
        length: 50,
        name: "code"
    })
    @Index({ unique: true })
    farmCode: string;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "name"
    })
    farmName: string;




    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "address"
    })
    address: string;
    @Column("int", {
        nullable: false,
        name: "no_of_acres"
    })
    NumberOfAcres: number;
    @Column("int", {
        nullable: false,
        name: "no_of_ponds"
    })
    numberOfPonds: number;
    @Column("varchar", {
        nullable: false,
        length: 100,
        name: "trace_code"
    })
    traceCode: string;
    @Column("int", {
        nullable: false,
        name: "certification_id"
    })
    certificationId: number;

    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "certification_code"
    })
    certificationCode: string;

    @Column("date", {
        nullable: false,
        name: "exp_date"
    })
    expiryDate: Date;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "mobile_no"
    })
    mobileNumber: string;
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @Column("boolean", {
        nullable: true,

        name: "culture_status"
    })
    cultureStatus: boolean;
    
    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "dealer"
    })
    dealerName: string;
    
    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "seed"
    })
    seed: string;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "feed"
    })
    feed: string;  
    
    @Column("varchar", {
        nullable: true,
        name: "remarks"
    })
    remarks: string;

    @Column("varchar", {
        nullable: true,
        name: "comments"
    })
    comments: string;

    @Column("int", {
        nullable: true,
        name: "area_under_culture_in_acrs"
    })
    AreaUnderCultureInAcrs: number;

    @Column("int", {
        nullable: true,
        name: "qty_stock"
    })
    qtyStock: number;
    @Column("varchar", {
        nullable: true,
        name: "date_of_stock_in"
    })
    dateOfStockIn: Date;
    @Column("int", {
        nullable: true,
        name: "day_of_culture"
    })
    dayOfCulture: number;
    @Column("int", {
        nullable: true,
        name: "count"
    })
    count: number;
    @Column("int", {
        nullable: true,
        name: "biomass_in_mts"
    })
    biomassInMts: number;

    @Column({
        type: 'enum',
        enum: FarmTypeEnum,
        nullable: false,
        name: 'farm_type',
    })
    farmType: FarmTypeEnum;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "reg_no"
    })
    regNum: string;

    @Column("boolean", {
        nullable: true,
        name: "reg_status"
    })
    regStatus: boolean;

    @ManyToOne(type => Supplier, supplier => supplier.farmInfo, { nullable: false, })
    @JoinColumn({ name: "farmer_id" })
    supplierInfo: Supplier;

    @OneToMany(type => FarmsLog, info => info.farmInfo, { cascade: true })
    farmLogInfo: FarmsLog;

}
